__turbopack_context__.v({
  "frame": "takeover-frame-component-module-scss-module__W0tBxW__frame",
  "frame__center-column": "takeover-frame-component-module-scss-module__W0tBxW__frame__center-column",
  "frame__rail": "takeover-frame-component-module-scss-module__W0tBxW__frame__rail",
  "frame__rail--left": "takeover-frame-component-module-scss-module__W0tBxW__frame__rail--left",
  "frame__rail--right": "takeover-frame-component-module-scss-module__W0tBxW__frame__rail--right",
  "frame__rail-image": "takeover-frame-component-module-scss-module__W0tBxW__frame__rail-image",
});
